<template><section>
<div class="page">
  <div>
    <h2>
      Adding a password
    </h2>
    <p>
      Adding a password can make your account more secure. Please never share your password with others.
    </p>
    <p>
      To add a password
    </p>
    <ol>
      <li>
      Go to <strong>Me</strong> tab in ToTok
      </li>
      <li>
        Tap <strong>Account</strong> > <strong>Password</strong>
      </li>
      <li>
        Set your new password. Then tap <strong>Save</strong>.
      </li>
    </ol>
    <h6>
      Note: ToTok doesn't have any feature that allows you to lock the app or certain chats with a password.
    </h6>



  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
